module.exports = __webpack_public_path__ + "files/dd663dd3eaf6a8a8d86d882a21e017f7.png";